import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import LabelIcon from '@mui/icons-material/Label';

import Swal from "sweetalert2";

import { Autocomplete, Button, Card, Chip, Fade, FormGroup, Grid, Hidden, IconButton, ListItemIcon, Menu, MenuItem, Modal, Stack, TextField, Tooltip, Typography } from "@mui/material";

import config from "../config";
import {
	updateFile,
	getFile,
	// generateLabels
} from '../services/file.service';
import showLoading from "src/common/loading";
import moment from "moment";
import { suggestLabels } from "src/services/label.service";
import DmonkLogo from 'src/assets/storageIcons/dmonk.png';
import GoogleDriveLogo from 'src/assets/storageIcons/googledrive.png';
import OneDriveLogo from 'src/assets/storageIcons/onedrive.png';
import DropboxLogo from 'src/assets/storageIcons/dropbox.png';

import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import { addContainer, getContainers } from "src/services/container.service";
import ContainersAutocomplete from "src/components/autocomplete/containers";
import FileAuditLogModal from "src/components/file-audit-log/FileAuditLog.modal";
import CommentModal from "src/components/comment/Comment.modal";
import constants from '../components/constants/common';
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined';
import { Redo, Undo, MoreVert } from "@mui/icons-material";
import FileWorkflows from "src/components/files/FileWorkflows";
import { editFile, viewFile } from "src/services/storage.service";
import AddIcon from '@mui/icons-material/Add';

const flags = constants.flags;

class AddEditFileModal extends React.Component {

	constructor(props) {
		super(props);
		this.state = {

			mode: 'edit',
			file_id: props?.file?._id,

			file: null,
			is_owner: false,

			name: '',
			suggested_name: '',
			ai_suggested_name: '',
			generated_names: [],
			flags: [],
			labels: [],
			note: '',
			label_suggestions: [],

			containers: [],
			container_suggestions: [],
			shared_users: [],

			loading: false,
			generating_labels: false,
			is_note_visible: false,
			generating_name: false,
			error: {},
		}
	}

	// promised setState
	setStateAsync(state) {
		return new Promise((resolve) => {
			this.setState(state, resolve)
		});
	}

	async componentDidMount() {
		try {

			showLoading(true);

			let file = await getFile(this.state.file_id)
			let logged_in_username = localStorage.getItem('username');

			if (file.error) {

				showLoading(false);

				Swal.fire({
					icon: 'error',
					title: 'Error',
					text: file.error,
					confirmButtonText: 'Ok',
					confirmButtonColor: config.primaryColor
				});
				return;
			}


			file = file.file

			let shared_users = file?.shared_users || [];
			if (shared_users.length > 0) {
				shared_users = shared_users.map(user => user.username);
			}

			this.setState({
				file: file,
				is_owner: (file.owner && file.owner.username === logged_in_username) || (file.co_owners && file.co_owners.length > 0 && file.co_owners.some(owner => owner.username === logged_in_username)),
				name: file.name,
				suggested_name: file.suggested_name ? file.suggested_name : file.name,
				ai_suggested_name: file.ai_suggested_name ? file.ai_suggested_name : file.name,
				flags: file?.flags ? file.flags : [],
				labels: file?.labels ? file.labels : [],
				note: file?.note ? file.note : '',
				shared_users: shared_users,
				containers: file?.containers ? file.containers.map(container => {
					return {
						id: container._id,
						label: container.name,
						name: container.name,
						type: container.type,
						color: container.color,
						is_owner: container.is_owner,
						automatically_created: container.automatically_created
					}
				}) : []
			})
			showLoading(false);

		} catch (error) {
			showLoading(false);
			console.error("Error fetching file details:", error)
		}
	}

	updateContainerSuggestions = async (params = null) => {
		try {

			let query = {
				limit: 10,
				skip: 0
			};

			let search;
			if (params) {
				search = params.target.value;
				query.search = search;
			}

			let containers = await getContainers(query);

			if (containers.error) {
				console.log("Error fetching containers:", containers.error);
				this.setState({
					container_suggestions: []
				});
				return;
			}

			containers = containers.containers;

			let container_suggestions = containers.map(container => {
				return {
					id: container._id,
					label: container.name,
					name: container.name,
					type: container.type,
					color: container.color,
					is_owner: container.is_owner,
					automatically_created: container.automatically_created
				}
			});

			if (search) {
				container_suggestions.push({
					id: search,
					label: `Create Group "${search}"`,
					name: `Create Group "${search}"`,
					type: 'container',
					is_owner: true,
					create: true
				});
			}

			this.setState({
				container_suggestions: container_suggestions
			});

		} catch (error) {
			console.error("Error fetching container suggestions:", error);
		}
	}


	saveFile = async () => {

		this.setState({
			loading: true
		});
		showLoading(true);

		let containers = this.state.containers.map(container => container.id);

		const payload = {
			name: this.state.name,
			suggested_name: this.state.suggested_name,
			flags: this.state.flags,
			labels: this.state.labels,
			note: this.state.note,
			containers: containers,
			shared_users: this.state.shared_users,
			organized: true
		}

		let save_file_response = await updateFile(this.state.file_id, payload);

		if (save_file_response.error) {

			showLoading(false);

			Swal.fire({
				icon: 'error',
				title: 'Error',
				text: save_file_response.error,
				confirmButtonText: 'Ok',
				confirmButtonColor: config.primaryColor
			}).then(() => {
				this.props.onSave();
			});
			this.setState({
				loading: false
			});
			return;
		}

		showLoading(false);
		this.setState({
			loading: false
		});

		Swal.fire({
			icon: 'success',
			title: 'Success',
			text: 'Saved successfully',
			confirmButtonText: 'Ok',
			confirmButtonColor: config.primaryColor
		});
		this.props.onSave();
	}

	// generateLabels = async () => {
	// 	try {

	// 		await this.setStateAsync({
	// 			generating_labels: true
	// 		});

	// 		let labels_response = await generateLabels(this.state.file_id);
	// 		if (labels_response.error) {
	// 			console.log("Error generating labels:", labels_response.error);
	// 			alert("Error generating labels - " + labels_response.error)
	// 			await this.setStateAsync({
	// 				generating_labels: false
	// 			});
	// 			return;
	// 		}

	// 		labels_response = labels_response.labels;

	// 		let labels = this.state.labels;
	// 		labels = labels.concat(labels_response.Keywords);

	// 		// unique labels
	// 		labels = [...new Set(labels)];

	// 		await this.setStateAsync({
	// 			generating_labels: false,
	// 			labels: labels
	// 		});
	// 	} catch (error) {
	// 		await this.setStateAsync({
	// 			generating_labels: false
	// 		});
	// 		alert("Unknown error occurred while generating labels - " + error.message)
	// 		console.log("Unknown error occurred while generating labels - ", error.message)
	// 	}
	// }

	generateNames = async () => {
		try {

			await this.setStateAsync({
				generating_name: true
			});

			let file = this.state.file;

			let file_name_without_extension = file.name.split('.').slice(0, -1).join('.');
			// sometimes files have no extension ( like google docs )
			if (!file_name_without_extension) {
				file_name_without_extension = file.name;
				file.extension = '';
			}


			// first 3 labels
			let first_3_labels = (this.state.labels && this.state.labels.length > 3) ? this.state.labels.slice(0, 3) : (this.state.labels ? this.state.labels : []);
			let generated_file_name = file_name_without_extension + (first_3_labels.length ? '_' + first_3_labels.join('_') : '') + (file.real_modified_at ? '_' + moment(file.real_modified_at).format("YYYYMMDD") : '') + (file.extension ? ('.' + file.extension) : '');
			let generated_file_name_2 = (first_3_labels.length ? first_3_labels.join('_') : '') + (file.real_modified_at ? '_' + moment(file.real_modified_at).format("YYYYMMDD") : '') + (file.extension ? ('.' + file.extension) : '');
			let generated_file_name_3 = file_name_without_extension + (file.real_modified_at ? '_' + moment(file.real_modified_at).format("YYYYMMDD") : '') + (file.extension ? ('.' + file.extension) : '');

			let generated_names = [];
			generated_names.push(generated_file_name);
			generated_names.push(generated_file_name_2);
			generated_names.push(generated_file_name_3);

			generated_names = [...new Set(generated_names)];

			await this.setStateAsync({
				generated_names: generated_names,
				generating_name: false
			});

		} catch (error) {
			await this.setStateAsync({
				generating_name: false,
				generated_names: []
			});
			alert("Unknown error occurred while generating name - " + error.message)
			console.log("Unknown error occurred while generating name - ", error.message)
		}
	}

	updateLabelSuggestions = async (e) => {

		let query = e.target.value;

		let label_suggestions = await suggestLabels({ query });

		this.setState({
			label_suggestions: label_suggestions?.next_labels ? label_suggestions.next_labels : []
		});
	}

	createContainer = async (container_name, type = 'container') => {
		let createdContainer = await addContainer({
			name: container_name,
			type: type
		})
		if (createdContainer.error) {
			return null;
		}
		return createdContainer.container;
	}

	editFile = async (file) => {
		try {

			this.setState({
				open_file_loading: true
			});

			const connected_service_id = file?.connected_service?._id || file?.connected_service;
			
			if (file.service == config.FILE_SERVICES.NEXTCLOUD || file.service == config.FILE_SERVICES.ONEDRIVE || file.service == config.FILE_SERVICES.GOOGLEDRIVE) {
				const response = await editFile(connected_service_id, file._id);
				if (response.error) {
					alert('Error editing file. Please try again later. Check connection status with Nextcloud');
					return;
				}
				const url = response.file;
				window.open(url, '_blank');
			} else if (file.type == 'excalidraw') {
				// do nothing
			} else {
				alert('File editing not supported for this service');
			}
		} catch (error) {
			alert("Unknown error occurred while editing file - " + error.message)
			console.log("Unknown error occurred while editing file - ", error.message)
		} finally {
			this.setState({
				open_file_loading: false
			});
		}
	}

	viewFile = async (file) => {
		try {

			this.setState({
				open_file_loading: true
			});

			const connected_service_id = file?.connected_service?._id || file?.connected_service;

			if (file.service == config.FILE_SERVICES.DROPBOX) {
				const response = await viewFile(connected_service_id, file._id);
				const url = response.file.preview_link;
				window.open(url, '_blank');
			} else if (file.service == config.FILE_SERVICES.ONEDRIVE) {
				window.open(file.external_details.webUrl, '_blank');
			} else if (file.service == config.FILE_SERVICES.GOOGLEDRIVE) {
				const response = await viewFile(connected_service_id, file._id);
				const url = response.file;
				window.open(url, '_blank');
			} else if (file.service == config.FILE_SERVICES.NEXTCLOUD) {
				const response = await viewFile(connected_service_id, file._id);
				if (response.error) {
					alert('Error viewing file. Please try again later. Check connection status with Nextcloud');
					return;
				}
				const url = response.file;
				window.open(url, '_blank');
			}
		} catch (error) {
			alert("Unknown error occurred while viewing file - " + error.message)
			console.log("Unknown error occurred while viewing file - ", error.message)
		} finally {
			this.setState({
				open_file_loading: false
			});
		}
	}

	render() {
		return (
			<div>
				<Modal
					open={this.props.open}
					onClose={() => {
						if (this.props.onClose)
							this.props.onClose();
					}}
				>
					<Fade in={this.props.open}>
						<Card sx={modalStyle}>
							<Grid container spacing={2} sx={{ p: 2, pb: 0 }} justifyContent={'center'} alignItems={'center'}>
								<Grid item xs={12}>
									<Stack spacing={1} direction={'row'}>

										<Grid display={'flex'} flex={1} flexDirection={'row'} alignItems="center">
											<Typography
												variant="h6"
												color="textSecondary"
												contentEditable={this.state.is_owner ? true : false}
												suppressContentEditableWarning={true}
												spellCheck={false}
												onBlur={(e) => {
													this.setState({
														isTitleFocussed: false,
														suggested_name: e.currentTarget.innerText
													});
												}}
												onFocus={() => {
													this.setState({
														isTitleFocussed: true
													});
												}}
												style={{
													alignItems: 'center',
													...(this.state.isTitleFocussed ? {} : {
														WebkitLineClamp: 2,
														WebkitBoxOrient: 'vertical',
														overflow: 'hidden',
														display: '-webkit-box',
														textOverflow: 'ellipsis',
														maxHeight: '2.8em'
													}),
													display: '-webkit-box',
													marginRight: '16px'
												}}
												sx={{
													fontSize: { xs: '0.725rem', md: '1rem' },
													textAlign: 'justify'
												}}
											>
												{this.state.suggested_name}
											</Typography>
											<Hidden mdDown>
												<Grid display={'flex'} flexDirection={'row'} alignItems="center">
													<Chip
														label="Open"
														size="small"
														variant="filled"
														onClick={() => {
															if (this.state.file.type === 'excalidraw') {
																this.props.navigate('/integrations/excalidraw/app?fileId=' + this.state.file._id);
																return;
															}

															if (this.state.file.service == config.FILE_SERVICES.NEXTCLOUD || this.state.file.service == config.FILE_SERVICES.ONEDRIVE || this.state.file.service == config.FILE_SERVICES.GOOGLEDRIVE) {
																this.editFile(this.state.file)
															} else {
																this.viewFile(this.state.file);
															}
														}}
														sx={{
															px: 2,
															py: 1,
															backgroundColor: 'black',
															color: 'white',
															'&:hover': {
																backgroundColor: '#333',
																cursor: 'pointer'
															}
														}}
													/>
												</Grid>
											</Hidden>
										</Grid>

										<Hidden mdDown>
											{(this.state.name !== this.state.suggested_name) && (
												<Grid display={'flex'} flexDirection={'row'} alignItems="center">
													<Tooltip title={"Revert to original name"} arrow>
														<IconButton
															onClick={() => {
																this.setState({
																	suggested_name_copy: this.state.suggested_name,
																	suggested_name: this.state.name
																});
															}}
														>
															<Undo fontSize="small" style={{ color: 'gray', opacity: 0.6 }} />
														</IconButton>
													</Tooltip>
												</Grid>
											)}
											{(this.state.name == this.state.suggested_name && this.state.suggested_name_copy) && (
												<Grid display={'flex'} flexDirection={'row'} alignItems="center">
													<Tooltip title={"Revert to previous name"} arrow>
														<IconButton
															onClick={() => {
																this.setState({
																	suggested_name: this.state.suggested_name_copy,
																	suggested_name_copy: null
																});
															}}
														>
															<Redo fontSize="small" style={{ color: 'gray', opacity: 0.6 }} />
														</IconButton>
													</Tooltip>
												</Grid>
											)}
											<FormGroup sx={{ flexDirection: 'row', alignItems: 'center' }} >
												{flags.map((flag, index) => {
													return (
														<Tooltip key={index} title={flag.label} arrow>
															<IconButton
																sx={{
																	border: this.state.flags.includes(flag.value) ? `1px solid ${flag.color}` : '',
																	marginRight: '5px',
																}}
																onClick={() => {
																	if (this.state.flags.includes(flag.value)) {
																		this.setState({
																			flags: this.state.flags.filter(f => f !== flag.value)
																		});
																	} else {
																		this.setState({
																			flags: [...this.state.flags, flag.value]
																		});
																	}
																}}
															>
																{this.state.flags.includes(flag.value) ? flag.iconSelected : flag.icon}
															</IconButton>
														</Tooltip>
													)
												})}
											</FormGroup>
										</Hidden>

										<Hidden mdUp>
											<Grid display={'flex'} flexDirection={'row'} alignItems="center">
												<IconButton
													onClick={(event) => {
														this.setState({ anchorEl: event.currentTarget });
													}}
												>
													<MoreVert fontSize="small" style={{ color: 'gray', opacity: 0.6 }} />
												</IconButton>
												<Menu
													anchorEl={this.state.anchorEl}
													open={Boolean(this.state.anchorEl)}
													onClose={() => this.setState({ anchorEl: null })}
												>
													{(this.state.name !== this.state.suggested_name) && (
														<MenuItem
															onClick={() => {
																this.setState({
																	suggested_name_copy: this.state.suggested_name,
																	suggested_name: this.state.name
																});
															}}
														>
															<ListItemIcon>
																<Undo fontSize="small" />
															</ListItemIcon>
															Undo
														</MenuItem>
													)}
													{(this.state.name == this.state.suggested_name && this.state.suggested_name_copy) && (
														<MenuItem
															onClick={() => {
																this.setState({
																	suggested_name: this.state.suggested_name_copy,
																	suggested_name_copy: null
																});
															}}
														>
															<ListItemIcon>
																<Redo fontSize="small" />
															</ListItemIcon>
															Redo
														</MenuItem>
													)}
													{flags.map((flag, index) => {
														return (
															<MenuItem
																onClick={() => {
																	if (this.state.flags.includes(flag.value)) {
																		this.setState({
																			flags: this.state.flags.filter(f => f !== flag.value)
																		});
																	} else {
																		this.setState({
																			flags: [...this.state.flags, flag.value]
																		});
																	}
																}}
															>
																<ListItemIcon>
																	{this.state.flags.includes(flag.value) ? flag.iconSelected : flag.icon}
																</ListItemIcon>
																{flag.label}
															</MenuItem>
														)
													})}
												</Menu>
											</Grid>
										</Hidden>

									</Stack>
								</Grid>

								<Hidden mdUp>
									<Grid item xs={12}>
										<Chip
											label="Open"
											size="small"
											variant="filled"
											onClick={() => {
												if (this.state.file.type === 'excalidraw') {
													this.props.navigate('/integrations/excalidraw/app?fileId=' + this.state.file._id);
													return;
												}

												if (this.state.file.service == config.FILE_SERVICES.NEXTCLOUD || this.state.file.service == config.FILE_SERVICES.ONEDRIVE || this.state.file.service == config.FILE_SERVICES.GOOGLEDRIVE) {
													this.editFile(this.state.file)
												} else {
													this.viewFile(this.state.file);
												}
											}}
											sx={{
												px: 2,
												py: 1,
												backgroundColor: 'black',
												color: 'white',
												'&:hover': {
													backgroundColor: '#333',
													cursor: 'pointer'
												}
											}}
										/>
									</Grid>
								</Hidden>

								{(this.state?.file?.what_is_it) && (
									<Grid item xs={12}>
										<Typography
											variant="body1"
											color="textSecondary"
											fontSize="0.7rem"
											sx={{
												fontSize: { xs: '0.7rem', md: '1rem' },
												textAlign: 'justify'
											}}
										>
											{this.state.file.what_is_it}
										</Typography>
									</Grid>
								)}

								<Grid item xs={12}>
									<FileWorkflows
										file={this.state.file}
									/>
								</Grid>

								<Grid item xs={12}>

									<Stack spacing={1} direction={'row'}>
										<ContainersAutocomplete
											label={"Part of"}
											disabled={!this.state.is_owner}
											containers={this.state.containers}
											onChange={(updatedContainers) => {
												this.setState({
													containers: updatedContainers
												});
											}}
										/>
									</Stack>
									<Stack spacing={1} direction={'row'} sx={{ marginTop: '10px' }}>
										<Chip
											icon={<AddIcon />}
											label="Note"
											size="small"
											variant={this.state.is_note_visible ? "filled" : "outlined"}
											onClick={() => this.setState({ is_note_visible: !this.state.is_note_visible })}
											sx={{ border: '0px' }}
										/>
										<Chip
											icon={<AddIcon />}
											label="Labels"
											size="small"
											variant={this.state.is_labels_visible ? "filled" : "outlined"}
											onClick={() => this.setState({ is_labels_visible: !this.state.is_labels_visible })}
											sx={{ border: '0px' }}
										/>
										<CommentModal
											file={this.state.file}
											is_modal_open={this.props.openComment}
										/>
									</Stack>
									{(this.state.is_note_visible) ? (
										<Stack spacing={1} direction={'row'} mt={1}>
											<TextField
												label={'Note'}
												placeholder="Add your note here..."
												variant="outlined"
												value={this.state.note}
												onChange={(e) => {
													this.setState({
														note: e.target.value
													});
												}}
												sx={{ flex: 1, marginTop: '10px' }}
												size="small"
												multiline
												minRows={2}
												maxRows={4}
											/>
										</Stack>
									) : null}
									{(this.state.is_labels_visible) ? (
										<Stack spacing={1} direction={'row'} mt={1}>
											<Autocomplete
												freeSolo
												multiple
												limitTags={3}
												id="labels-outlined"
												options={this.state.label_suggestions}
												value={this.state.labels}
												onChange={(event, newValue) => {
													this.setState({
														labels: newValue
													});
												}}
												onFocus={() => this.setState({ labelsFocused: true })}
												onBlur={() => this.setState({ labelsFocused: false })}
												renderTags={(tagValue, getTagProps) => {
													if (this.state.labelsFocused) {
														// Show all chips while focused
														return tagValue.map((option, index) => (
															<Chip
																{...getTagProps({ index })}
																size="small"
																key={option}
																label={option}
																variant="outlined"
															/>
														));
													}

													// Show only first 4 chips when blurred
													const visible = tagValue.slice(0, 4);
													const remaining = tagValue.length - visible.length;

													return (
														<>
															{visible.map((option, index) => (
																<Chip
																	{...getTagProps({ index })}
																	size="small"
																	key={option}
																	label={option}
																	variant="outlined"
																/>
															))}

															{remaining > 0 && (
																<Chip
																	size="small"
																	label={`+${remaining} more`}
																	variant="outlined"
																	sx={{ ml: 0.5 }}
																/>
															)}
														</>
													);
												}}
												renderInput={(params) => (
													<TextField
														{...params}
														variant="outlined"
														label="Labels"
														placeholder="What is it ?"
														InputProps={{
															...params.InputProps,
															endAdornment: (
																<React.Fragment>
																	{params.InputProps.endAdornment}
																	<LabelIcon />
																</React.Fragment>
															),
															enterKeyHint: 'enter'
														}}
														onChange={this.updateLabelSuggestions}
													/>
												)}
												fullWidth
												size="small"
												enterKeyHint='enter'
											/>
										</Stack>
									) : null}
								</Grid>

								<Grid item xs={12}>
									<Button
										fullWidth
										variant="contained"
										onClick={this.saveFile}
										disabled={this.state.loading}
										size="small"
									>
										{this.state.loading ? 'Organizing...' : 'Organize'}
									</Button>
								</Grid>

								<Grid item xs={12} direction={'row'} style={{ paddingTop: 0 }}>
									<Stack spacing={1} direction={'row'} mb={1} justifyContent={"space-between"} alignItems={"center"}>

										<Stack spacing={1} direction={'row'} alignItems={"center"}>

											{(this.state?.file?.connected_service?.type == config.FILE_SERVICES.ONEDRIVE) && (
												<img src={OneDriveLogo} style={{ height: '20px', width: "20px" }} />
											)}
											{(this.state?.file?.connected_service?.type == config.FILE_SERVICES.DROPBOX) && (
												<img src={DropboxLogo} style={{ height: '20px', width: "20px" }} />
											)}
											{(this.state?.file?.connected_service?.type == config.FILE_SERVICES.GOOGLEDRIVE) && (
												<img src={GoogleDriveLogo} style={{ height: '20px', width: "20px" }} />
											)}
											{(this.state?.file?.connected_service?.type == config.FILE_SERVICES.NEXTCLOUD) && (
												<img src={DmonkLogo} style={{ height: '20px', width: "20px" }} />
											)}

											{/* Owners */}
											{((this.state.file?.owner) || (this.state.file?.co_owners && this.state.file?.co_owners.length > 0) || (this.state.file?.owner_emails && this.state.file?.owner_emails.length > 0)) ? (
												<Stack spacing={0} direction={'row'} alignItems={'center'}>
													{/* Icon */}
													<ShieldOutlinedIcon fontSize="small" style={{ color: 'gray', opacity: 0.6 }} />
													{/* owner */}
													{(this.state.file?.owner) ? (
														<Stack spacing={0} direction={'row'} alignItems={'center'}>
															<Chip
																size="small"
																label={this.state.file?.owner?.name ? this.state.file?.owner?.name : this.state.file?.owner?.username}
																variant="outlined"
																sx={{ m: 1, marginLeft: 0, borderRadius: '5px', opacity: 0.6, border: 'none' }}
															/>
														</Stack>
													) : null}
													{/* co_owners list */}
													{(this.state.file?.co_owners && this.state.file?.co_owners.length > 0) ? (
														// Chip fields
														<Stack spacing={0} direction={'row'} alignItems={'center'}>
															{this.state.file?.co_owners.map((co_owner, index) => {
																return (
																	<Chip
																		size="small"
																		key={index}
																		label={co_owner?.name ? (co_owner?.name + ' (' + co_owner?.username + ')') : co_owner?.username}
																		variant="outlined"
																		sx={{ m: 1, borderRadius: '5px', opacity: 0.6, border: 'none' }}
																	/>
																)
															})}
														</Stack>
													) : null}
													{(this.state.file?.owner_emails && this.state.file?.owner_emails.length > 0) ? (
														// Chip fields
														<Stack spacing={0} direction={'row'} alignItems={'center'}>
															{this.state.file?.owner_emails.map((owner_email, index) => {
																return (
																	<Chip
																		size="small"
																		key={index}
																		label={owner_email}
																		variant="outlined"
																		sx={{ m: 1, borderRadius: '5px', opacity: 0.6, border: 'none' }}
																	/>
																)
															})}
														</Stack>
													) : null}
												</Stack>
											) : null}

											{/* Shared Users */}
											<Hidden mdDown>
												{((this.state.file?.shared_users && this.state.file?.shared_users.length > 0) || (this.state.file?.shared_user_emails && this.state.file?.shared_user_emails.length > 0)) ? (
													<Stack spacing={0} direction={'row'} alignItems={'center'}>
														{/* Icon */}
														<PeopleAltIcon fontSize="small" style={{ color: 'gray', opacity: 0.6 }} />
														{/* Owners list */}
														{(this.state.file?.shared_users && this.state.file?.shared_users.length > 0) ? (
															// Chip fields
															<Stack spacing={0} direction={'row'} alignItems={'center'}>
																{this.state.file?.shared_users.map((shared_user, index) => {
																	return (
																		<Chip
																			size="small"
																			key={index}
																			label={shared_user?.name ? shared_user?.name : shared_user?.username}
																			variant="outlined"
																			sx={{ m: 1, borderRadius: '5px', opacity: 0.6, border: 'none' }}
																		/>
																	)
																})}
															</Stack>
														) : null}
														{(this.state.file?.shared_user_emails && this.state.file?.shared_user_emails.length > 0) ? (
															// Chip fields
															<Stack spacing={0} direction={'row'} alignItems={'center'}>
																{this.state.file?.shared_user_emails.map((shared_user_email, index) => {
																	return (
																		<Chip
																			size="small"
																			key={index}
																			label={shared_user_email}
																			variant="outlined"
																			sx={{ m: 1, borderRadius: '5px', opacity: 0.6, border: 'none' }}
																		/>
																	)
																})}
															</Stack>
														) : null}
													</Stack>
												) : null}
											</Hidden>

										</Stack>

										<Hidden mdDown>
											{/* Created and Modified At */}
											<Stack spacing={0} direction={'row'} alignItems={'center'}>
												{(this.state.file?.real_created_at) ? (
													<Chip
														size="small"
														label={"Created : " + moment(this.state.file?.real_created_at).format('LLL')}
														variant="outlined"
														sx={{ m: 1, borderRadius: '5px', opacity: 0.3, border: 'none' }}
													/>
												) : null}
												{(this.state.file?.real_modified_at) ? (
													<Chip
														size="small"
														label={"Modified : " + moment(this.state.file?.real_modified_at).format('LLL')}
														variant="outlined"
														sx={{ m: 1, borderRadius: '5px', opacity: 0.3, border: 'none' }}
													/>
												) : null}
											</Stack>

											{/* Original File Name */}
											{(this.state.file?.name && this.state.file.suggested_name !== this.state.file?.name) ? (
												<Stack spacing={0} direction={'row'} alignItems={'center'}>
													<Chip
														size="small"
														label={"Original Name : " + this.state.file?.name}
														variant="outlined"
														sx={{ m: 1, borderRadius: '5px', opacity: 0.2, border: 'none' }}
													/>
												</Stack>
											) : null}
										</Hidden>

										<FileAuditLogModal
											view_type='icon'
											file={this.state.file}
										/>

									</Stack>
								</Grid>
							</Grid>
						</Card>
					</Fade>
				</Modal>
			</div>
		);
	}
}

const modalStyle = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: '80%',
	bgcolor: 'background.paper',
	boxShadow: 24,
	maxHeight: '90%',
	overflowY: 'auto'
};

// Wrap and export
export default function (props) {
	const params = useParams();
	const navigate = useNavigate();
	return <AddEditFileModal {...props} navigate={navigate} params={params} />;
}